import { IconArrowLeft as ArrowLeft } from "@tabler/icons-react";
import { SectionHeader } from "../components/shared/SectionHeader";

export function ImprintPage({ t }) {
  return (
    <main>
      <section className="relative overflow-hidden pt-32 pb-24 md:pt-40 md:pb-32">
        <div
          className="orb"
          style={{
            width: 440,
            height: 440,
            background: "hsl(var(--brand) / 0.18)",
            top: 80,
            right: -140,
          }}
        />

        <div className="container-x relative">
          <a href="/" className="btn-pill btn-ghost mb-10 w-fit text-sm">
            <ArrowLeft className="h-4 w-4" />
            {t.imprint.back}
          </a>

          <SectionHeader eyebrow={t.imprint.eyebrow} title={t.imprint.title} />

          <div className="reveal mt-12 grid gap-6 lg:grid-cols-3">
            {t.imprint.sections.map((group) => (
              <section
                key={group.title}
                className="rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--surface))] p-6 md:p-7"
              >
                <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">
                  {group.title}
                </h3>
                <div className="mt-5 space-y-2 text-base leading-relaxed">
                  {group.lines.map((line) => (
                    <p key={line}>{line}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>

          <section className="reveal mt-6 rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--surface))] p-6 md:p-7">
            <div className="space-y-8">
              {t.imprint.additionalSections.map((group) => (
                <div key={group.title}>
                  <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">
                    {group.title}
                  </h3>
                  <div className="mt-4 space-y-3 text-base leading-relaxed">
                    {group.paragraphs.map((paragraph) => (
                      <p key={paragraph}>{paragraph}</p>
                    ))}
                    {group.link ? (
                      <a
                        href={group.link.href}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex text-brand underline underline-offset-4"
                      >
                        {group.link.label}
                      </a>
                    ) : null}
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </section>
    </main>
  );
}
